module.exports = __webpack_public_path__ + "img/dragonz_buzzingarden.e2a14f2.png";